export const CLIENT_ERROR_MESSAGE = 'Unusual activity detected';
export const ACTION_TYPES = {
  EVENT_REGISTRATION: 'event_registration'
};
export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];
